<template lang="pug">
.cp-service
  .banner
    p.p1 服务
    p.p2 SERVICE
  #after-sale
    .w
      h2 售后服务
      h3 After-sale Service
      .info1
        .item.item1.ani-card
          h4 适用产品
          p 弗徕威智能服务机器人产品
        .item.item2.ani-card
          h4 保修期限
          p
            b 整机：
            span 1年
          p
            b 主要部件（如电机）：
            span 1年
          p
            b 配套智能设备及电池：
            span 6个月
        .item.item3.ani-card
          h4 维修方式
          p 通过正规快递寄回弗徕威售后服务中心维修，维修完毕后会联系您寄出，产品包装箱请妥善保管，以便产品维修时使用
      .info2.ani-card
        h4 维修费用
        p 保修期内：非使用不当原因造成的产品损坏，弗徕威负责免费维修
        p 保修期外：由消费者付费维修，弗徕威会根据损坏状况收取一定维修费用（含快递费用）
      .tip 以上政策适用于消费者在中国大陆所购买的弗徕威产品，并遵循中国相关的“三包”规定
  #maintenance
    .w
      h2 报修方式
      h3 Maintenance
      .tab-wrap-mobile(v-if="isMobile")
        .tab(:class="[currentMobileTab.name]")
          h4 {{currentMobileTab.title}}
          p(v-html="currentMobileTab.info")
          .btn-prev(@click="prevTab", v-show="mobileTabIndex > 0") <
          .btn-next(@click="nextTab", v-show="mobileTabIndex < (typeList.length-1)") >
        .img(
          v-for="(item, index) in typeList",
          v-show="index === mobileTabIndex",
          :class="[item.name]",
        )
      .tab-wrap(v-else)
        .tab(v-for="item in typeList", @mouseover="setTab(item.name)", :class="[{active: tab === item.name}, item.name]")
          h4 {{item.title}}
          p(v-html="item.info")
          .img(:class="[item.name]", v-show="item.name === tab")
      .tip
        |服务时间为
        b 周一至周五9:00-18:00
        |，法定节假日休息。
        br
        | 报修时明确告知您所使用的产品型号、产品序列号、详细的故障现象等，以便快捷为您服务。
  #qa
    .w
      h2 服务问答
      h3 Questions & Answers
      .list
        .item.ani-card(v-for="item in qaList")
          p
            i.icon.q Q
            span.q {{item.question}}
          p
            i.icon.a A
            span {{item.answer}}
</template>

<script>
export default {
  data () {
    return {
      tab: 'tel',
      mobileTabIndex: 0,
      typeList: [
        {
          name: 'tel',
          title: '拨打电话',
          info: '拨打售后服务电话：193 0215 5869'
        },
        {
          name: 'app',
          title: 'APP中提交',
          info: '登录手机APP，在个人中心的“问题反馈”，<br>填写故障信息'
        },
        {
          name: 'weixin',
          title: '微信号提交',
          info: '关注微信号“弗徕威服务机器人（Flw_service ）”进行在线报修 <br>'
        },
      ],
      qaList: [
        {
          question: '每次使用机器人前，都需要手动连接网络和外设吗？',
          answer: '不需要，第一次使用时需要手动同步连接，以后使用会自动连接。除非路由器配置（名称或密码）更改时，机器人需要通过手动再次连接。'
        },
        {
          question: '如果家里正在播出的电视机节目中出现“打开窗户”、“过来”等语音对话，是否会误导机器人执行相关指令？',
          answer: '不会。因为对机器人发出的语音指令，前面需一起附带机器人的名字，首先唤醒机器人，如“维拉，你好”等，后面发出的指令才会有效，故一般不会出现电视机节目中出现诸如“打开窗户”、“过来”等语音对话时，会误导机器人执行相关指令。另外在未来，弗徕威家用服务机器人还会支持用户给机器人自定义名字。'
        }
      ]
    }
  },
  computed: {
    currentMobileTab () {
      return this.typeList[this.mobileTabIndex]
    }
  },
  methods: {
    setTab (key) {
      this.tab = key
    },
    prevTab () {
      if (this.mobileTabIndex > 0) this.mobileTabIndex --
    },
    nextTab () {
      if (this.mobileTabIndex < (this.typeList.length-1)) this.mobileTabIndex ++
    },
  },
  created () {},
}
</script>

<style lang="stylus">
@import 'config'
.cp-service
  color #333
  font-size 14px
  h2
    font-size 30px
    text-align center
  h3
    font-size 16px
    text-align center
  .banner
    width 100%
    height 240px
    background url(../assets/web/banner-service.jpg) center
    background-size auto 100%
    color #fff
    font-size 18px
    display flex
    justify-content center
    align-items center
    flex-direction column
    .p1
      font-size 40px
  #after-sale
    background-color #f5f7f9
    padding 65px 0 40px
    .info1
      text-align center
      margin 30px 0
      .item
        display inline-block
        background-color #fff
        vertical-align top
        width 350px
        height 200px
        &.item2
          margin 0 30px
        h4
          font-size 18px
          padding 25px 0
          margin-bottom 20px
          background url(../assets/web/bd1.png) bottom center no-repeat
        p
          color #666
      .item1
        p
          padding-top 25px
      .item2
        p
          text-align left
          padding-left 90px
          line-height 1.7
      .item3
        p
          padding 0 20px
          text-align left
    .info2
      background-color #fff
      width 350px * 3 + 60
      margin 0 auto
      padding-bottom 30px
      h4
        font-size 18px
        padding 25px 0
        margin-bottom 20px
        text-align center
        background url(../assets/web/bd1.png) bottom center no-repeat
      p
        padding-left 290px
        color #666
    .tip
      text-align center
      margin-top 40px
      color #999
  #maintenance
    padding 70px 0 45px
    .tab-wrap
      position relative
      .tab
        width 510px
        height 150px
        transition 1s all
        background-position 50px center
        background-repeat no-repeat
        padding-left 125px
        &.active,
        &:hover
          background-color #f5f7f9
        &.tel
          background-image url(../assets/web/icon-tel.png)
        &.app
          background-image url(../assets/web/icon-app2.png)
        &.weixin
          background-image url(../assets/web/icon-weixin2.png)
        h4
          padding-top 40px
          font-weight bold
          font-size 18px
          margin-bottom 10px
        p
          color #666
      .img
        position absolute
        top 0
        right 0
        width 620px
        height 100%
        background-position center
        background-repeat no-repeat
        animation fadeRight 1.3s forwards
        &.tel
          background-image url(../assets/web/server-tel.png)
        &.app 
          background-image url(../assets/web/server-app.png)
        &.weixin
          background-image url(../assets/web/server-weixin.png)

    .tip
      text-align center
      padding-top 30px
      color #999
      b
        color #3bc0bc
  #qa
    background-color #f5f7f9
    padding 65px 0 40px
    .list
      .item
        background-color #fff
        margin-top 30px
        padding 30px
        p
          margin-bottom 15px
          overflow hidden
          .icon
            float left
            width 30px
            height 30px
            line-height 30px
            text-align center
            &.q
              background-color #3bc0bc
              color #fff
            &.a
              background-color #f5f7f9
              color #3bc0bc
          span
            float left
            margin-left 15px
            width 1050px
            color #666
            line-height 30px
            &.q
              font-size 18px
              color #333
.is-mobile
  .cp-service
    .banner
      height r(100)
      background-image url(../assets/mobile/banner-news.jpg)
      .p1
        font-size r(30)
      .p2
        font-size r(20)
    h2
      background #fff
      font-size r(30)
      padding-top r(20)
    h3
      background #fff
      font-size r(20)
      padding-bottom r(20)
    #after-sale
      padding 0
      .info1
        margin r(20) auto
        .item
          width r(670)
          height r(226)
          margin r(10) 0
          h4
            font-size r(24)
            padding r(20) 0 r(10)
        .item1
          p
            padding-top r(30)
        .item2
          p
            padding-left r(160)
            font-size r(22)
        .item3
          p
            font-size r(22)
      .info2
        width r(670)
        height r(226)
        margin r(10) auto
        h4
          font-size r(24)
          padding r(20) 0 r(10)
          margin-bottom r(20)
        p
          padding 0 20px
          font-size r(20)
      .tip
        font-size r(22)
        padding r(35)
        margin 0
        text-align left
    #maintenance
      padding 0
      .tip
        font-size r(22)
        padding r(100)
      .tab-wrap-mobile
        .tab
          position relative
          margin 0 auto
          width r(660)
          height r(150)
          background #f5f7f9
          transition 1s all
          background-position r(100) center
          background-repeat no-repeat
          padding r(36) r(70) 0 r(160)
          &.tel
            background-image url(../assets/web/icon-tel.png)
          &.app
            background-image url(../assets/web/icon-app2.png)
          &.weixin
            background-image url(../assets/web/icon-weixin2.png)
          background-size auto r(40)
          p
            font-size r(22)
          .btn-prev,
          .btn-next
            position absolute
            top 0
            width r(76)
            height r(150)
            line-height r(150)
            background #ebeff3
            text-align center
          .btn-prev
            left 0
          .btn-next
            right 0
        .img
          width 100%
          height r(900)
          background-position center
          background-repeat no-repeat
          animation fadeDown 1.3s forwards
          &.tel
            background-image url(../assets/web/server-tel.png)
          &.app
            background-image url(../assets/web/server-app.png)
          &.weixin
            background-image url(../assets/web/server-weixin.png)



    #qa
      padding 0
      .list
        .item
          margin r(30)
          padding r(30)
          p
            margin-bottom r(20)
            .icon
              width r(35)
              height r(35)
              line-height r(35)
              font-size r(22)
            span
              line-height r(35)
              width r(540)
              margin-left r(20)
              font-size r(22)
              &.q
                font-size r(30)
</style>



// WEBPACK FOOTER //
// src/views/service.vue